import React from 'react';
import ReportingMarketingPromoCodesPage from '../components/ReportingMarketingPromoCodesPage';

const ReportingMarketingPromoCodesApp = (props) => (
  <ReportingMarketingPromoCodesPage {...props} />
);

export default ReportingMarketingPromoCodesApp;
